customElements.get("related-products") || customElements.define("related-products", class extends HTMLElement {
  #t=!1;
  #e=null;
  #s=new Set;
  #r=null;
  get #a() {
    return this.dataset.url?.match(/product_id=([0-9]+)/)?.[1];
  }
  async #i() {
    if (!this.#t && this.dataset.url) {
      this.#t = !0, this.toggleAttribute("data-loading", !0), this.#e?.abort(), this.#e = new AbortController;
      try {
        const t = await fetch(this.dataset.url, {
          signal: this.#e.signal
        });
        if (!t.ok) throw new Error(`HTTP ${t.status}`);
        const e = (new DOMParser).parseFromString(await t.text(), "text/html"), s = e.querySelector(this.tagName.toLowerCase()), r = !!s?.innerHTML.trim();
        r && this.innerHTML !== s.innerHTML && (this.innerHTML = s.innerHTML, this.classList.remove("hidden"), 
        setTimeout(() => this.classList.remove("opacity-0"), 100)), requestAnimationFrame(() => {
          this.closest("shopping-cart")?.toggleAttribute("data-has-recommendations", r);
        });
        const a = e.querySelector("[data-labels]");
        a && this.closest('.shopify-section:not([id*="drawer"])')?.querySelectorAll("[data-labels]").forEach(t => t.innerHTML = a.innerHTML), 
        this.dispatchEvent(new CustomEvent("related-products:state", {
          detail: {
            hasContent: r,
            loading: !0
          },
          bubbles: !0
        }));
      } catch (t) {
        "AbortError" !== t.name && console.warn("Failed to fetch related products:", t);
      } finally {
        this.#t = !1, this.toggleAttribute("data-loading", !1);
        const t = this.#n();
        this.dispatchEvent(new CustomEvent("related-products:state", {
          detail: {
            hasContent: t,
            loading: !1
          },
          bubbles: !0
        }));
      }
    }
  }
  #n() {
    const t = this.querySelector("[data-slider]");
    return t ? t.children.length > 0 : this.innerHTML.trim().length > 0 && !this.classList.contains("hidden");
  }
  #o(t) {
    return this.#s.add(t), t;
  }
  #l() {
    if (this.hasAttribute("data-lazy")) {
      const t = this.#h();
      this.#o(new IntersectionObserver(([t]) => {
        t.isIntersecting && (this.#i(), this.#s.forEach(t => t.disconnect()));
      }, {
        rootMargin: `0px 0px ${window.innerHeight}px 0px`
      })).observe(t);
    }
    this.hasAttribute("data-update") && (this.#r = t => {
      const e = t.detail?.url;
      "string" == typeof e && e !== this.dataset.url && (this.dataset.url = e), this.#i();
    }, this.addEventListener("related-products:update", this.#r)), this.hasAttribute("data-pdp-height") && (this.classList.remove("hidden"), 
    setTimeout(() => this.classList.remove("opacity-0"), 100));
  }
  #h() {
    const t = this.dataset.lazyObserverRoot || "self";
    return "section" === t ? this.closest(".shopify-section") || this : "parent" === t ? this.parentElement || this : "selector" === t && this.dataset.lazyObserverSelector && document.querySelector(this.dataset.lazyObserverSelector) || this;
  }
  async connectedCallback() {
    this.hasAttribute("data-lazy") || await this.#i(), this.#l();
  }
  disconnectedCallback() {
    this.#e?.abort(), this.#s.forEach(t => t.disconnect()), this.#s.clear(), this.#r && (this.removeEventListener("related-products:update", this.#r), 
    this.#r = null);
  }
  update() {
    return this.#i();
  }
});